import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'

import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Image } from '@/components/atoms/Image/Image'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { ImageTextSectionProps } from './types'

export function ImageWithText({ image, heading, title, description = '', cta_button, reverse }: ImageTextSectionProps) {
  return (
    <section className="mx-auto max-w-screen-desktop p-24 laptop:px-90 laptop:py-64" id={kebabCase(title)}>
      <div
        key={title}
        className={clsx(
          'flex flex-col-reverse netbook:flex-row netbook:!items-center',
          reverse ? 'netbook:flex-row-reverse netbook:justify-end' : 'netbook:justify-between'
        )}
      >
        <div className={clsx('relative w-full netbook:w-5/12 netbook:max-w-lg flex flex-col mt-20 netbook:my-auto')}>
          <Image fixed={false} fluid data={image} options={{ width: 500 }} />
        </div>
        <div className={clsx('w-full netbook:w-1/2 flex flex-col netbook:mb-0 netbook:max-w-38', reverse && 'mr-32')}>
          <p
            className="text-bodyL netbook:self-start font-poppins
            text-primary-600 tracking-wide uppercase font-bold mb-24 text-left"
          >
            {heading}
          </p>
          <h2
            className="text-text-dark-900 text-left netbook:self-start text-headingM-mobile netbook:text-headingM
            font-bold font-poppins mb-24"
          >
            {title}
          </h2>
          <div className="text-bodyM text-text-dark-900 netbook:w-full mb-16 netbook:max-w-lg">
            <RichTextField data={description} />
          </div>
          {cta_button.length > 0 && (
            <CustomLink {...cta_button[0]} className="flex items-center">
              <p className="text-bodyL font-bold text-primary-600 hover:text-primary-500">{cta_button[0].text}</p>
              <i className="fa fa-long-arrow-right text-primary-600 hover:text-primary-500 ml-8" />
            </CustomLink>
          )}
        </div>
      </div>
    </section>
  )
}
